import axios from 'axios';

const EMAIL_API_URL = 'https://common.a-traq.com/api/email/send-email'; 

/**
 * Sends an email using the backend API.
 * 
 * @param {string} to - Recipient email address
 * @param {string} subject - Email subject
 * @param {string} htmlContent - HTML content of the email
 * @returns {Promise<boolean>} - True if successful, false otherwise
 */
export const sendEmail = async (to, subject, htmlContent) => {
    try {
        await axios.post(EMAIL_API_URL, {
            to: to,
            subject: subject,
            html: htmlContent // Changed from 'email' to 'html' to matches backend expectation
        });

        return true; 
    } catch (error) {
        // Log detailed error response if available for easier debugging
        if (error.response) {
            console.error("Error sending email:", error.response.status, error.response.data);
        } else {
            console.error("Error sending email:", error.message);
        }
        return false;
    }
};
